// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1E206","right":"Footer_right__eG9ym","buttons":"Footer_buttons__2c6jF"};